import {
  searchThema,
  getThemaCodes,
  type GetThemaCodesData,
  type SearchThemaData,
} from "reedy-data/api";
import { BaseApi } from "./base";

export type ThemaCodesParams = GetThemaCodesData["query"];
export type ThemaSearchParams = SearchThemaData["query"];

export class ThemaApi extends BaseApi {
  async getCodes(params?: ThemaCodesParams) {
    const response = await this.request(getThemaCodes, {
      query: params,
    });
    return response?.data;
  }

  async search(params: ThemaSearchParams) {
    const response = await this.request(searchThema, {
      query: params,
    });
    return response?.data;
  }
}
